var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataRede(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.198,
    height: 29.197,
    viewBox: "0 0 29.198 29.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.198,
    height: 29.197
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.635,177.718l-2.464-1.929a14.533,14.533,0,0,0-2.979,7.234l3.112.343a11.416,11.416,0,0,1,2.331-5.648",
    transform: "translate(-3.09 -170.149)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.131,456.585l-3.131,0a14.653,14.653,0,0,0,.126,1.831l3.1-.431a11.517,11.517,0,0,1-.1-1.4",
    transform: "translate(0 -441.935)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.34,544.215l-3.035.77a14.481,14.481,0,0,0,.573,1.754l2.9-1.181a11.381,11.381,0,0,1-.437-1.343",
    transform: "translate(-13.846 -526.753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.666,6.126l-.35-3.111a14.566,14.566,0,0,0-8.665,4.206l2.237,2.188a11.441,11.441,0,0,1,6.778-3.283",
    transform: "translate(-128.395 -2.918)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.721,0l.005,3.132A11.467,11.467,0,1,1,58.565,20.1L55.813,21.6A14.6,14.6,0,1,0,68.721,0",
    transform: "translate(-54.022)",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRede);
export default __webpack_public_path__ + "static/media/data-rede.06245868af719d43d6a7646d0bbc4542.svg";
export { ForwardRef as ReactComponent };